import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../libs/models/user/user.model';
import { OrganizationUser } from '../../libs/models/organization/organization-user.model';
import { Candidate } from '../../libs/models/candidate/candidate.model';
import { FirestoreDocument } from '../../libs/shared/models/firestore-document';
import { DEFAULT_FALLBACK_VALUE } from '../utils/constants';

@Pipe({
  name: 'name',
})
export class NamePipe implements PipeTransform {
  transform(
    value: FirestoreDocument<User | OrganizationUser | Candidate> | null | undefined,
    opts: FullPipeOptions = {}
  ): string {
    const { mode = 'fullName', fallback = DEFAULT_FALLBACK_VALUE } = opts;
    if (!value) return fallback;

    const first = value.data.firstName?.trim() ?? '';
    const last = value.data.lastName?.trim() ?? '';
    if (!first && !last) return fallback;

    switch (mode) {
      case 'initials':
        const f = first ? first[0] + '.' : '';
        const l = last ? last : '';
        return [f, l].filter(Boolean).join(' ').trim() || fallback;
      case 'firstName':
        return first || fallback;
      case 'lastName':
        return last || fallback;
      case 'fullName':
      default:
        return [first, last].filter(Boolean).join(' ') || fallback;
    }
  }
}

interface FullPipeOptions {
  mode?: 'fullName' | 'initials' | 'firstName' | 'lastName';
  fallback?: string;
}
